module.exports = __webpack_public_path__ + "static/media/icon_status_break.3dd751b2.svg";